import {BaseEntity} from '../../app-common/data/BaseEntity';

export class Mail extends BaseEntity<number> {
  communicationId: number;
  carrier: string;
  trackingNumber: string;
  returnReceipt: string;
  receivedOrSentDate: Date;
  hasChecks: boolean;
  hasProblems: boolean;
  problems: string;
  fileSavedAs: string;
  filePath: string;
  problemReturnToSender: boolean;
  problemReturnMail: boolean;
  problemReturnUserId: string | null;
  problemReturnDate: Date;
  problemCB: boolean;
  problemStipulations: boolean;
  problemHearing: boolean;
  problemRenewals: boolean;
  problemCNC: boolean;
  problemDenials: boolean;
  problemOutOfState: boolean;
  hasDateScanned: boolean;
  dateScanned: Date;
  assigned: boolean;
}

